export function showBootstrapError(): void {
  document.getElementById('bootstrap-error')?.removeAttribute('hidden');
}
